import type { ListItemBlock } from '@atlas/renderer';
import isListBlock, { type ListBlock } from '@atlas/tool/box/slate/isListBlock';

export default function extractItemsFromListBlock(listBlock: ListBlock): ListItemBlock[] {
    return listBlock.children.reduce<ListItemBlock[]>((all, child) => {
        if (!isListBlock(child)) return all.concat(child);
        return all.concat(extractItemsFromListBlock(child));
    }, []);
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('extractItemsFromListBlock', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
